import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineManufacturerSelect from '../inputs/InlineManufacturerSelect';
import InlineItemSelect from '../inputs/InlineItemSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineCategorySelect from '../inputs/InlineCategorySelect';


class PreferredItemGuidance extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      item_ids: initialValues.item_ids ? _.join(initialValues.item_ids) : '',
      manufacturer_ids: initialValues.manufacturer_ids || [],
      excluded_manufacturer_ids: initialValues.excluded_manufacturer_ids || [],
      excluded_item_ids: initialValues.excluded_item_ids ? _.join(initialValues.excluded_item_ids) : '',
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0],
      supplier_ids: initialValues.supplier_ids || [],
      excluded_supplier_ids: initialValues.excluded_supplier_ids || [],
      category_ids: initialValues.category_ids || [],
      excluded_category_ids: initialValues.excluded_category_ids || []
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const state = _.omit(this.state, 'regions');
    const value = Object.assign({}, state, {
      item_ids: this.state.item_ids ? _.map(this.state.item_ids.split(','), item => parseInt(item, 10)) : [],
      excluded_item_ids: this.state.excluded_item_ids ? _.map(this.state.excluded_item_ids.split(','), item => parseInt(item, 10)) : [],
      category_ids: this.categoriesAllowed() ? this.state.category_ids : [],
      excluded_category_ids: this.categoriesAllowed() ? this.state.excluded_category_ids : [],
    });
    this.props.onSubmit({
      kind: 'preferred_item',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  categoriesAllowed() {
    return !_.isEmpty(this.state.supplier_ids || !_.isEmpty(this.state.manufacturer_ids));
  }

  render() {
    const {
      regions,
      supplier_ids,
      excluded_supplier_ids,
      manufacturer_ids,
      excluded_manufacturer_ids,
      item_ids,
      excluded_item_ids
    } = this.state;
    const {
      form, type, isCorporate, ...other
    } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          placeholder='All suppliers by default'
          showSearch={true}
          mode='multiple'
          label='Suppliers'
          description='Suppliers to be selected'
          value={supplier_ids}
          onChange={id => this.setState({ supplier_ids: id })}
          include_all={false}
          include_any={false}
        />
        <InlineSupplierSelect
          placeholder='No suppliers excluded by default'
          showSearch={true}
          mode='multiple'
          label='Excluded Suppliers'
          description='Suppliers to be excluded if they are the only supplier available for a given item'
          value={excluded_supplier_ids}
          onChange={id => this.setState({ excluded_supplier_ids: id })}
          include_all={false}
          include_any={false}
        />
        <InlineManufacturerSelect
          label='Manufacturers'
          value={manufacturer_ids}
          placeholder='All manufacturers by default'
          showSearch={true}
          onChange={manufacturerIds => this.setState({ manufacturer_ids: manufacturerIds })}
        />
        <InlineManufacturerSelect
          label='Excluded Manufacturers'
          description='Manufacturers to be excluded'
          value={excluded_manufacturer_ids}
          placeholder='No manufacturers excluded by default'
          showSearch={true}
          onChange={excludedManufacturerIds => this.setState({ excluded_manufacturer_ids: excludedManufacturerIds })}
        />
        <InlineItemSelect
          value={item_ids}
          onChange={itemIds => this.setState({ item_ids: itemIds })}
        />
        <InlineItemSelect
          label='Excluded Items'
          description='Items to be excluded'
          value={excluded_item_ids}
          onChange={excludedItemIds => this.setState({ excluded_item_ids: excludedItemIds })}
        />
        <InlineCategorySelect
          label='Categories'
          placeholder='All categories by default'
          description={
            'Categories to be included. You may only include these if you specify preferred '
            + 'suppliers and/or manufacturers.'
          }
          value={this.categoriesAllowed() ? this.state.category_ids : this.initialState.category_ids}
          onChange={category_ids => this.setState({ category_ids })}
          disabled={_.isEmpty(this.state.supplier_ids) && _.isEmpty(this.state.manufacturer_ids)}
        />
        <InlineCategorySelect
          label='Excluded Categories'
          placeholder='No categories excluded by default'
          description={
            'Categories to be excluded. You may only include these if you specify preferred '
            + 'suppliers and/or manufacturers.'
          }
          value={this.categoriesAllowed() ? this.state.excluded_category_ids : this.initialState.excluded_category_ids}
          onChange={excluded_category_ids => this.setState({ excluded_category_ids })}
          disabled={_.isEmpty(supplier_ids) && _.isEmpty(manufacturer_ids)}
        />
      </RuleForm>
    );
  }
}

PreferredItemGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

PreferredItemGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
  corporate: PropTypes.object,
  isCorporate: PropTypes.bool,
};

export default PreferredItemGuidance;
